type GetUnhandledErrorEventsToIgnore = () => string[];

export const getUnhandledErrorEventsToIgnore: GetUnhandledErrorEventsToIgnore = () => [
  'ResizeObserver loop limit exceeded',
  'CKEditorError',
];

export const containsErrorEventsToIgnore = (errorMessage: string): boolean =>
  getUnhandledErrorEventsToIgnore().some((unhandledErrorEventToIgnore) =>
    errorMessage.includes(unhandledErrorEventToIgnore)
  );
